import { createSlice } from "@reduxjs/toolkit";
import { backendConnector } from "../backendIntegration/lambdas";
import { createApiThunk, addAsyncCases } from "./sliceHelpers";

// The My Jobs scoreboard (NEXT-STAGE-PLAN essential 7). The server is the only thing that decides
// what may be shown, so this slice stores the payload as it arrived and adds nothing: computing a
// rate here from `applications` and `responses` is exactly the dishonest number the endpoint
// withholds on purpose. A failed fetch leaves `data` null and the strip renders nothing, which is
// better than a header of zeroes.

export const fetchScoreboard = createApiThunk(
  "scoreboard/fetch",
  () => backendConnector.getScoreboard(),
  { logMessage: "Error fetching the scoreboard:", errorMessage: "Failed to load your scoreboard" }
);

const initialState = { data: null, loading: false, loaded: false, error: null };

export const scoreboardSlice = createSlice({
  name: "scoreboard",
  initialState,
  reducers: {
    clearScoreboard: () => initialState,
  },
  extraReducers: (builder) => {
    addAsyncCases(builder, fetchScoreboard, {
      loadingKey: "loading",
      loadedKey: "loaded",
      onFulfilled: (state, action) => {
        state.data = action.payload ?? null;
      },
      onRejected: (state, action) => {
        state.data = null;
        state.error = typeof action.payload === "string" ? action.payload : "Failed to load your scoreboard";
      },
    });
  },
});

export const { clearScoreboard } = scoreboardSlice.actions;
export default scoreboardSlice.reducer;
